export function bicosInRequest(params = {}) {
  return {
    type: '@bico/BICOS_IN_REQUEST',
    payload: { params },
  };
}

export function findBico(id) {
  return {
    type: '@bico/FIND_BICO',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@bico/FAILED_REQUEST',
  };
}

export function deleteBico(idbico, params) {
  return {
    type: '@bico/DELETE_BICO',
    payload: { idbico, params },
  };
}

export function updateBico(bico, params) {
  return {
    type: '@bico/UPDATE_BICO',
    payload: { bico, params },
  };
}

export function storeBico(bico, params) {
  return {
    type: '@bico/STORE_BICO',
    payload: { bico, params },
  };
}

export function successInRequest(
  bicos,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@bico/SUCCESS_IN_REQUEST',
    payload: { bicos, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(bico) {
  return {
    type: '@bico/SUCCESS_REQUEST',
    payload: { bico },
  };
}

export function successRemove(params) {
  return {
    type: '@bico/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@bico/RECORD_FILTERING',
    payload: { params },
  };
}
